import { VideoTag } from "./video-tag";

export class VideoTagUserVideo{
  hash: string;
  start: number;
  duration: number;
  videoTags: Array<VideoTag> = [];
  history: {
    "viewHash": String,
    "scenes": Array<{
      "s": Number,    // タグ区間の相対start位置
      "e": Number     // タグ区間の相対end位置
    }>
  } = null;

  constructor(object = null){

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.hash){
      this.hash = object.hash;
    }
    if(((typeof object.start) === "number")){
      this.start = object.start;
    }
    if(((typeof object.duration) === "number")){
      this.duration = object.duration;
    }
    if(Array.isArray(object.videoTags)){
      for(const videoTagObject of object.videoTags){
        this.videoTags.push(new VideoTag(videoTagObject));
      }
    }
  }

  serialize(){
    let object = {
      "hash": this.hash,
      "start": this.start,
      "duration": this.duration,
      "videoTags": [],
      "history": this.history
    };
    for(const videoTag of this.videoTags){
      object.videoTags.push(videoTag.serialize());
    }
    return object;
  }

  generateHistory(viewHash, baseHistory){
    if(!Array.isArray(baseHistory)){
      return;
    }
    let history = {
      viewHash: viewHash,
      scenes: []
    }
    for(let scene of baseHistory){
      if(scene.e || scene.p){
        let e = (scene.e != null) ? scene.e : scene.p;
        if((this.start + this.duration) <= scene.s){
          continue;
        }
        else if(e <= this.start){
          continue;
        }

        let s = scene.s;
        if(s <= this.start){
          s = 0;
        }
        else{
          s -= this.start;
        }
        if((this.start + this.duration) <= e){
          e = this.duration;
        }
        else{
          e -= this.start;
        }

        if(e < s){
          e = s;
        }

        history.scenes.push({
          "s": Math.max(s, 0),
          "e": Math.max(e, 0)
        });
      }
    }
    if(history.scenes.length > 0){
      this.history = history;
    }
  }
}